import type { ReactNode } from 'react'
import React from 'react'

import { useModalContext } from '@fourthwall/components'

import { AddPaymentMethodModalView } from './AddPaymentMethodModalView'

type AddPaymentMethodModalContainerProps = {
  title?: string
  subtitle?: ReactNode
  submitLabel?: string
  withChargeLimit?: boolean
  onSuccess?: () => void
  onCancel?: () => void
}

export const AddPaymentMethodModalContainer = ({
  title = 'Add a new payment method',
  subtitle,
  submitLabel = 'Save',
  withChargeLimit = true,
  onSuccess,
  onCancel,
}: AddPaymentMethodModalContainerProps) => {
  const { close } = useModalContext()

  const handleSuccess = () => {
    close()
    onSuccess?.()
  }

  const handleClose = () => {
    close()
    onCancel?.()
  }

  return (
    <AddPaymentMethodModalView
      title={title}
      subtitle={subtitle}
      submitLabel={submitLabel}
      withChargeLimit={withChargeLimit}
      onSuccess={handleSuccess}
      onClose={handleClose}
    />
  )
}
